import { type GTM } from '@vakantiesnl/types';

import { basicGTMV2Event } from './basicGTMV2Event';

export const homePageView = (): GTM.GTMEventV2 =>
	basicGTMV2Event({
		type: 'view',
		organism: null,
		molecule: null,
		atom: null,
		action: 'page_view',
		page_type: 'homePage',
		sub_page: null,
		label: null,
		value: {},
	});
